import { VerticalData } from './vertical';

export const rsaMediaTypeData = [
  {
    name: 'Digital',
    lowerQuartile: '7%',
    median: '15.7%',
    upperQuartile: '35%',
  },
  {
    name: 'TV',
    lowerQuartile: '21.1%',
    median: '44.7%',
    upperQuartile: '62.7%',
  },
  {
    name: 'OOH',
    lowerQuartile: '37.2%',
    median: '154.4%',
    upperQuartile: '180.5%',
  },
] as const satisfies readonly VerticalData[];

export const rsaDigitalVerticalData = [
  {
    name: 'Dining',
    lowerQuartile: '7.7%',
    median: '19.8%',
    upperQuartile: '50.3%',
  },
  {
    name: 'Entertainment*',
    lowerQuartile: '9.5%',
    median: '10.7%',
    upperQuartile: '27.3%',
  },
  {
    name: 'Retail',
    lowerQuartile: '6.5%',
    median: '14.9%',
    upperQuartile: '29.1%',
  },
  {
    name: 'Telecom*',
    lowerQuartile: '18.8%',
    median: '18.8%',
    upperQuartile: '18.8%',
  },
] as const satisfies readonly VerticalData[];

export const rsaDigitalSubverticalData = [
  {
    name: 'Dining - Fast Casual',
    lowerQuartile: '6.7%',
    median: '11.4%',
    upperQuartile: '20.5%',
  },
  {
    name: 'Dining - QSR',
    lowerQuartile: '7.9%',
    median: '23.1%',
    upperQuartile: '57.6%',
  },
  {
    name: 'Retail - Alc-Bev*',
    lowerQuartile: '0.2%',
    median: '1.4%',
    upperQuartile: '2.9%',
  },
  {
    name: 'Retail - Automotive',
    lowerQuartile: '11.9%',
    median: '30.7%',
    upperQuartile: '50.3%',
  },
  {
    name: 'Retail - Beauty',
    lowerQuartile: '14.8%',
    median: '18.9%',
    upperQuartile: '28.3%',
  },
  {
    name: 'Retail - Big Box',
    lowerQuartile: '11.6%',
    median: '22.6%',
    upperQuartile: '45.8%',
  },
  {
    name: 'Retail - Clothing',
    lowerQuartile: '5.5%',
    median: '12.3%',
    upperQuartile: '24.4%',
  },
  {
    name: 'Retail - Convenience',
    lowerQuartile: '0.1%',
    median: '5.1%',
    upperQuartile: '16.4%',
  },
  {
    name: 'Retail - Drug',
    lowerQuartile: '17.5%',
    median: '53.9%',
    upperQuartile: '302.5%',
  },
  {
    name: 'Retail - Furniture*',
    lowerQuartile: '10.1%',
    median: '32.1%',
    upperQuartile: '55%',
  },
  {
    name: 'Retail - Grocery',
    lowerQuartile: '6.8%',
    median: '13%',
    upperQuartile: '17.3%',
  },
  {
    name: 'Retail - Home Improvement',
    lowerQuartile: '9.2%',
    median: '17.2%',
    upperQuartile: '26%',
  },
  {
    name: 'Retail - Pet*',
    lowerQuartile: '30.8%',
    median: '45.9%',
    upperQuartile: '263.6%',
  },
  {
    name: 'Retail - Sporting Goods*',
    lowerQuartile: '5.1%',
    median: '6.7%',
    upperQuartile: '17.2%',
  },
] as const satisfies readonly VerticalData[];

export const rsaTvVerticalData = [
  {
    name: 'Dining',
    lowerQuartile: '21.1%',
    median: '44.7%',
    upperQuartile: '62.7%',
  },
] as const satisfies readonly VerticalData[];

export const rsaTvSubverticalData = [
  {
    name: 'Dining - Fast Casual*',
    lowerQuartile: '12.8%',
    median: '24.3%',
    upperQuartile: '35.7%',
  },
  {
    name: 'Dining - QSR*',
    lowerQuartile: '24.2%',
    median: '44.7%',
    upperQuartile: '72.7%',
  },
] as const satisfies readonly VerticalData[];

export const rsaOohVerticalData = [
  {
    name: 'Dining*',
    lowerQuartile: '36.1%',
    median: '89.4%',
    upperQuartile: '210.2%',
  },
  {
    name: 'Retail',
    lowerQuartile: '91.5%',
    median: '158.8%',
    upperQuartile: '180.5%',
  },
] as const satisfies readonly VerticalData[];

export const rsaOohSubverticalData = [
  {
    name: 'Dining - Fast Casual*',
    lowerQuartile: '340.7%',
    median: '340.7%',
    upperQuartile: '340.7%',
  },
  {
    name: 'Dining - QSR*',
    lowerQuartile: '25.7%',
    median: '69.8%',
    upperQuartile: '69.8%',
  },
  {
    name: 'Retail - Automotive*',
    lowerQuartile: '155.2%',
    median: '163.1%',
    upperQuartile: '163.1%',
  },
  {
    name: 'Retail - Clothing*',
    lowerQuartile: '127.2%',
    median: '166.1%',
    upperQuartile: '166.1%',
  },
  {
    name: 'Retail - Grocery*',
    lowerQuartile: '5.8%',
    median: '6.6%',
    upperQuartile: '6.6%',
  },
] as const satisfies readonly VerticalData[];
